import { useEffect, useState } from "react";
import { EditIcon } from "../../icon";
import { LoadChannels } from '../../actions';
import { ChannelUserModel, UserModel, mapToChannelUser } from "../../models/users.model";
import { mapToUser } from "../../models/conversations";
import { ToasterType } from '../shared/toaster/toaster.model';
import { dateComparator } from "../shared/grid/grid.services";
import { UtilityService } from '../../services/UtilityService';
import { AvatarRenderer } from '../shared/grid/avatarRenderer';
import { StatusRenderer } from '../shared/grid/statusRenderer';
import { ActionsRenderer } from '../shared/grid/actionsRenderer';
import { setBackHandler, setHeaderTitle, } from "../../helpers/header.helper";
import { ChannelService } from '../../services/channels/ChannelAcountService';
import { ChannelAccountModel, ChannelAccountStatus, ChannelType } from '../../models/channels/channels.model';
import { ColDef, ICellRendererParams, ValueFormatterParams, ValueGetterParams } from 'ag-grid-community';
import { AddChannelicon, DisconnectBtnIcon, TrashIcon, ConnectBtnIcon, ViewPageIcon } from "../../icon";
import { GridStatusLabelVariant, ActionLabels, buttonLabels, DialogHeaders, emptyLabels, ToasterTexts, appNote } from '../shared/constants';
import GridComponentNew from '../shared/grid';
import setToast from '../../helpers/toaster.helper';
import EditChannelComponent from './edit-channel.component';
import ConfirmDialog from "../shared/confirm-dialog.component";
import ButtonComponent from '../shared/button/button.component';
import FacebookChannelViewComponent from './add-facebook-channel.component';
import FbInstaHeaderIcon from "../../icons/fb-insta-combined-header-icon.svg";
import WhatsAppIcon from "../../icons/channel-whatsapp-icon.svg";

import { useNavigate, useParams } from "react-router-dom";
import { Card } from "@mui/material";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import * as selector from '../../selectors/selectors';

interface IProps extends ChannelAccountModel {
    CloseFacebookCard: () => void;
}

const AddChannel = (props: IProps) => {
    const params = useParams()
    const dispatch = useDispatch()
    const Channels: ChannelAccountModel[] = useSelector(selector.Channels)
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)

    const [addChannel, setAddChannel] = useState<boolean>(false);
    const [isDeleted, setIsDeleted] = useState<boolean>(false);
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [isConnect, setIsConnect] = useState<boolean>(false);
    const [buttonName, setButtonName] = useState("")
    const [text, setText] = useState("")
    const [selectedRow, setSelectedRow] = useState<ChannelAccountModel>()
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [gridApi, setGridApi] = useState<any>();
    const [columnApi, SetColumnApi] = useState<any>(null)
    const navigate = useNavigate();

    const channelType = Number(params.Type)
    const user = mapToChannelUser(JSON.parse(localStorage.getItem("current-user"))) as ChannelUserModel;

    useEffect(() => {
        setHeaderTitle(
            channelType === ChannelType.FACEBOOK ? DialogHeaders.FACEBOOK_MESSANGER
                : channelType === ChannelType.INSTAGRAM ? DialogHeaders.INSTAGRAM_MESSANGER
                    : channelType === ChannelType.MESSENGER ? DialogHeaders.FACEBOOK_MESSANGER : DialogHeaders.WHATSAPP_MESSANGER
        );
        setBackHandler(() => navigate(-1));
        if (!Channels || Channels.length === 0) {
            LoadChannels(dispatch, user.OrganizationID)
        }
    }, [])

    const openAddChannel = () => {
        setAddChannel(true);
    }

    const closeChannel = (refresh?: boolean) => {
        setAddChannel(false);
        if (refresh) {
            LoadChannels(dispatch, user.OrganizationID)
        }
    }

    const editChannel = (data?: ChannelAccountModel) => {
        setIsEdit(true);
        setSelectedRow(data);
    }

    const closeEditChannel = () => {
        setIsEdit(false);
    }
    const openConnectDialog = (data: ChannelAccountModel, action: string) => {
        let text = data.Status === ChannelAccountStatus.CONNECTED ? appNote.DISCONNECT_CHANNEL : appNote.CONNECT_CHANNEL;
        setIsConnect(true);
        setSelectedRow(data);
        setText(text);
        setButtonName(action);
    }

    const closeConnectDialog = (isConfim: boolean) => {
        let status = selectedRow?.Status;
        setIsLoading(true);
        if (!!isConfim) {
            if (status === ChannelAccountStatus.CONNECTED) {
                ChannelService.disableChannelAccount(user.OrganizationID, selectedRow?.ID, user.ID)
                    .then(() => {
                        setToast(ToasterTexts.DISCONNECT_CHANNEL.replace('<Name>', selectedRow?.Name), ToasterType.SUCCESS)
                        setIsConnect(false);
                        setSelectedRow(undefined);
                        LoadChannels(dispatch, user.OrganizationID)
                        setIsLoading(false);
                    }).catch((error: any) => {
                        setToast(ToasterTexts.SOMETHING_WENT_WRONG_MESSAGE, ToasterType.DANGER)
                        setIsConnect(false);
                        setSelectedRow(undefined);
                        setIsLoading(false);
                    })
            }
            else {
                ChannelService.enableChannelAccount(user.OrganizationID, selectedRow?.ID, user.ID)
                    .then(() => {
                        setToast(ToasterTexts.CONNECT_CHANNEL.replace('<Name>', selectedRow?.Name), ToasterType.SUCCESS)
                        setIsConnect(false);
                        setSelectedRow(undefined);
                        setIsLoading(false);
                        LoadChannels(dispatch, user.OrganizationID)
                    }).catch((error: any) => {
                        setIsConnect(false);
                        setSelectedRow(undefined);
                        setIsLoading(false);
                    })
            }
        } else {
            setIsConnect(false);
            setSelectedRow(undefined);
            setIsLoading(false);
        }
    };

    const closeConfirmDialog = (isConfim: boolean) => {
        if (!!isConfim) {
            setIsLoading(true);
            ChannelService.deleteChannelAccount(user.OrganizationID, selectedRow?.ID)
                .then(() => {
                    setToast(ToasterTexts.CHANNEL_DELETE_SUCCESS.replace('<Name>', selectedRow?.Name), ToasterType.SUCCESS)
                    setIsDeleted(false);
                    setSelectedRow(undefined);
                    LoadChannels(dispatch, user.OrganizationID);
                    setIsLoading(false);
                }).catch((error: any) => {
                    setToast(ToasterTexts.SOMETHING_WENT_WRONG_MESSAGE, ToasterType.DANGER)
                    setIsDeleted(false);
                    setSelectedRow(undefined);
                    setIsLoading(false);
                })
        } else {
            setIsDeleted(false);
            setSelectedRow(undefined);
            setIsLoading(false);
        }
    };

    const openConfirmDialog = (data: ChannelAccountModel) => {
        setIsDeleted(true);
        setSelectedRow(data);
    };

    const ChanelsColoumnDefs: ColDef[] = [
        {
            field: "Name",
            headerName: "Account",
            valueGetter: (params: ValueGetterParams) => {
                return `${params.data.Name}`
            },
            cellRendererSelector: (params: ICellRendererParams) => {
                const AvatarComponent = {
                    component: AvatarRenderer,
                    params: {
                        SetName: params.data.Name,
                        ShowBadgeIcon: false,
                        HideAvatar: IsMobileDevice,
                        Icon: params.data.ChannelIcon ? params.data.ChannelIcon : ""
                    }
                }
                if (params.data) {
                    return AvatarComponent
                }
                return undefined
            },
            resizable: true,
            minWidth: 200
        },

        {
            field: "Status",
            headerName: "Status",
            valueGetter: (params: ValueGetterParams) => {
                return params.data.Status === ChannelAccountStatus.CONNECTED ? "Connected" : params.data.Status === ChannelAccountStatus.DISCONNECTED ? "Disconnected" : "Pending Validation";
            },
            cellRendererSelector: (params: ICellRendererParams) => {
                if (params.data) {
                    const label = params.data.Status === ChannelAccountStatus.CONNECTED ? "Connected" : params.data.Status === ChannelAccountStatus.DISCONNECTED ? "Disconnected" : "Pending Validation";
                    const variant = params.data.Status === ChannelAccountStatus.CONNECTED ? GridStatusLabelVariant.Active : params.data.Status === ChannelAccountStatus.DISCONNECTED ? GridStatusLabelVariant.Danger : GridStatusLabelVariant.Warning;
                    const Status = {
                        component: StatusRenderer,
                        params: {
                            Variant: variant, Label: label, Id: params.data.ID
                        }
                    }
                    return Status
                }
                return undefined
            },
            resizable: true,
            minWidth: 200
        },
        {
            field: "UpdatedDate",
            headerName: "Last updated",
            valueFormatter: (params: ValueFormatterParams) => {
                return UtilityService.convertDateToDay(params.value).toString()
            },
            valueGetter: (params: ValueGetterParams) => {
                return UtilityService.convertDateToDay(params.data.UpdatedDate).toString()
            },
            sort: !IsMobileDevice ? 'desc' : null,
            hide: IsMobileDevice,
            comparator: (valueA, valueB, nodeA, nodeB) => dateComparator(nodeA.data.UpdatedDate, nodeB.data.UpdatedDate),
            resizable: true,
            minWidth: 200
        },
        {
            field: "Action",
            maxWidth: 40,
            headerName: "",
            pinned: "right",
            lockPinned: true,
            lockPosition: "right",
            cellClass: "ag-cell-actions-style",
            headerClass: "bg-color-secondary",
            cellRenderer: params =>
                <ActionsRenderer
                    MenuData={getMenuActions(params.data)}
                    {...params}
                />,
            resizable: false,
            sortable: false,
        },
    ]

    const getMenuActions = (data: ChannelAccountModel) => {
        return [
            {
                Name: ActionLabels.EDIT,
                Icon: EditIcon,
                OnClick: () => editChannel(data),
            },
            {
                Name: data.Status === ChannelAccountStatus.CONNECTED ? ActionLabels.DISCONNECT : ActionLabels.CONNECT,
                Icon: data.Status === ChannelAccountStatus.CONNECTED ? DisconnectBtnIcon : ConnectBtnIcon,
                OnClick: () => openConnectDialog(data, data?.Status === ChannelAccountStatus.CONNECTED ? ActionLabels.DISCONNECT : ActionLabels.CONNECT),
            },
            {
                Name: ActionLabels.VIEWPAGE,
                Icon: ViewPageIcon,
                OnClick: () => { window.open(data.ChannelRedirectUrl, "_blank") },
            },
            // {
            //     Name: ActionLabels.REAUTHORIZE,
            //     Icon: ReauthorizeIcon,
            //     OnClick: () => { },
            // },
            {
                Name: ActionLabels.DELETE,
                Icon: TrashIcon,
                OnClick: () => openConfirmDialog(data),
            },
        ]
    }

    const onGridReady = (params) => {
        setGridApi(params.api)
        SetColumnApi(params.columnApi)
    }
    return (
        <div className='w-fill h-p-100 w-p-100 bg-color-channel-background'>
            <div className=' pt-1 '>
                <Card className={`box-shadow-channel m-2`} classes={{ root: 'pb-0' }} >
                    <div className={`d-flex  br-2 `}>
                        <div className='p-3'>
                            {channelType === ChannelType.FACEBOOK ? <img src={FbInstaHeaderIcon} className="mt-2" alt={"fbinstaicon"}></img> : <img src={WhatsAppIcon} className="mt-1 w-8 h-8" alt={"fbinstaicon"}></img>}
                        </div>
                        <div className='p-3'>
                            <div className='color-channel-fb-tile h2-semibold'>
                                {channelType === ChannelType.FACEBOOK ? "Facebook + Instagram Messenger" : channelType === ChannelType.WHATSAPP ? "Whatsapp Messenger" : "Instagram Messenger"}
                            </div>
                            <div className='h6-regular color-channel-confirm-label w-p-45'>
                                {channelType === ChannelType.FACEBOOK ? "We'll redirect you to Facebook where you can add Facebook and Instagram Messenger channels. Please make sure to select all the Pages you'd like to connect."
                                    :
                                    channelType === ChannelType.WHATSAPP ? "We'll redirect you to Facebook where you can add Whatsapp Messenger channels. Please make sure to select all the Pages you'd like to connect."
                                        : "We'll redirect you to Instagram where you can add Messenger channels to your Inbox. Please make sure to select all of the pages you'd like connected."}
                            </div>
                        </div>
                        <div className={"d-flex align-center w-space ml-auto mt-1 mr-2"}>
                            <ButtonComponent ButtonLabel={buttonLabels.ADD_PAGE} Variant={"primary-btn"} Icon={AddChannelicon} OnClick={() => openAddChannel()} />
                        </div>
                    </div>
                    <div className='bg-color-channel-fb-border-box p-1'></div>
                </Card>
            </div>

            <div className="h-p-75">
                <GridComponentNew
                    ColumnDefs={ChanelsColoumnDefs}
                    IsPaginationEnabled={true}
                    OnGridReady={onGridReady}
                    RowData={channelType === ChannelType.WHATSAPP ? [...Channels.filter(x => x.ChannelType === ChannelType.WHATSAPP)] : [...Channels.filter(x => x.ChannelType === ChannelType.FACEBOOK), ...Channels.filter(x => x.ChannelType === ChannelType.INSTAGRAM)]}
                    EmptyLabel={emptyLabels.CHANNELS}
                    LockVisible={false}
                />
            </div>

            {addChannel &&
                <FacebookChannelViewComponent Show={addChannel}
                    CloseChannel={closeChannel} IsMobileDevice={IsMobileDevice} ChannelType={channelType} />
            }

            {isEdit &&
                <EditChannelComponent
                    Show={isEdit}
                    Channel={selectedRow}
                    CloseEditChannel={closeEditChannel}
                />
            }

            {isConnect &&
                <ConfirmDialog
                    ButtonName={buttonName}
                    onClose={closeConnectDialog}
                    Show={isConnect}
                    Text={text}
                    Loading={isLoading}
                ></ConfirmDialog>
            }
            {isDeleted &&
                <ConfirmDialog
                    ButtonName={buttonLabels.DELETE}
                    onClose={closeConfirmDialog}
                    Show={isDeleted}
                    Text={appNote.CHANNEL_DELETE}
                    Loading={isLoading}
                ></ConfirmDialog>
            }
        </div>
    );
}

export default AddChannel;